import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TaskEntity } from '@core/entities';
import { IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-task-compact-card',
  imports: [CommonModule, DatePipe, TranslateModule, IconComponent],
  templateUrl: './task-compact-card.component.html',
  styleUrls: ['./task-compact-card.component.scss'],
})
export class TaskCompactCardComponent {
  @Input() task: TaskEntity = new TaskEntity();

  get statusLabel(): string {
    switch (this.task.status) {
      case 'ToDo':
        return 'To Do';
      case 'InProgress':
        return 'In Progress';
      case 'Completed':
        return 'Completed';
      default:
        return String(this.task.status);
    }
  }

  get statusClass(): string {
    switch (this.task.status) {
      case 'ToDo':
        return 'task-compact-card__status--todo';
      case 'InProgress':
        return 'task-compact-card__status--in-progress';
      case 'Completed':
        return 'task-compact-card__status--completed';
      default:
        return '';
    }
  }
}
